import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ChannelsEffects, channelsReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([ChannelsEffects]), StoreModule.forFeature(`channels`, channelsReducer)]
})
export class ChannelsStateModule {}
